// Intercepts all replaceState calls to inject selling_plan into the URL when active
let activePlanId = null
const originalReplaceState = window.history.replaceState.bind(window.history)
window.history.replaceState = function (state, title, url) {
  if (url && activePlanId) {
    const newUrl = new URL(url, window.location.origin)
    newUrl.searchParams.set('selling_plan', activePlanId)
    originalReplaceState(state, title, newUrl.toString())
  } else {
    originalReplaceState(state, title, url)
  }
}

function findProductForm() {
  return document.querySelector('form[is="product-form"]') || document.querySelector('form[action*="/cart/add"]')
}

function resolveSellingPlanInput(form) {
  if (!form) return null
  let el = form.querySelector('input[type="hidden"][name="selling_plan"]')
  if (el) return el
  el = form.querySelector('input[name="selling_plan"]:not(#sub-toggle-input)')
  if (el) return el
  el = document.createElement('input')
  el.type = 'hidden'
  el.name = 'selling_plan'
  el.setAttribute('data-pdm-subscription-toggle', '')
  form.appendChild(el)
  return el
}

function initPdmSubscriptionToggle() {
  if (window.__pdmSubscriptionToggleInitialized) return

  const productForm = findProductForm()
  const subSelect = document.querySelector('.sub-select')
  const trigger = document.querySelector('.sub-select__trigger')
  const triggerLabel = trigger && trigger.querySelector('.sub-select__trigger-label')
  const options = document.querySelectorAll('.sub-select__option')
  const sellingPlanInput = resolveSellingPlanInput(productForm)
  const toggle = document.querySelector('#sub-toggle-input')

  if (!subSelect || !trigger || !toggle || !sellingPlanInput) return

  window.__pdmSubscriptionToggleInitialized = true

  function openSelect() {
    subSelect.setAttribute('aria-expanded', 'true')
    subSelect.classList.add('sub-select--open')
  }

  function closeSelect() {
    subSelect.setAttribute('aria-expanded', 'false')
    subSelect.classList.remove('sub-select--open')
  }

  function setSellingPlan(id) {
    if (!id) return
    activePlanId = id
    sellingPlanInput.disabled = false
    sellingPlanInput.setAttribute('value', id)
    sellingPlanInput.value = id
    window.history.replaceState({}, '', window.location.href)
  }

  function removeSellingPlan() {
    activePlanId = null
    sellingPlanInput.removeAttribute('value')
    sellingPlanInput.value = ''
    sellingPlanInput.disabled = true
    const url = new URL(window.location.href)
    url.searchParams.delete('selling_plan')
    originalReplaceState({}, '', url)
  }

  function selectOption(option) {
    options.forEach((o) => {
      o.classList.remove('sub-select__option--selected')
      o.setAttribute('aria-selected', 'false')
    })
    option.classList.add('sub-select__option--selected')
    option.setAttribute('aria-selected', 'true')

    const label = option.querySelector('.sub-select__label')
    if (triggerLabel && label) triggerLabel.textContent = label.textContent
  }

  trigger.addEventListener('click', (e) => {
    e.stopPropagation()
    subSelect.classList.contains('sub-select--open') ? closeSelect() : openSelect()
  })

  toggle.addEventListener('change', (e) => {
    if (e.target.checked) {
      const selected = subSelect.querySelector('.sub-select__option--selected')
      if (selected) setSellingPlan(selected.dataset.value)
    } else {
      removeSellingPlan()
      if (options[0]) selectOption(options[0])
    }
  })

  options.forEach((option) => {
    option.addEventListener('click', (e) => {
      e.stopPropagation()
      selectOption(option)
      setSellingPlan(option.dataset.value)
      closeSelect()
    })
  })

  document.addEventListener('click', () => closeSelect())

  function checkInitialState() {
    if (toggle.checked) {
      const selected = subSelect.querySelector('.sub-select__option--selected')
      if (selected) setSellingPlan(selected.dataset.value)
    } else {
      removeSellingPlan()
    }
  }

  const urlPlanId = new URL(window.location.href).searchParams.get('selling_plan')
  if (urlPlanId) {
    const matchedOption = [...options].find((o) => o.dataset.value === urlPlanId)
    if (matchedOption) {
      selectOption(matchedOption)
      setSellingPlan(urlPlanId)
      toggle.checked = true
    }
  }

  checkInitialState()
}

function bootPdmSubscriptionToggle() {
  initPdmSubscriptionToggle()
  if (window.__pdmSubscriptionToggleInitialized) return
  let attempts = 0
  const poll = setInterval(function () {
    initPdmSubscriptionToggle()
    if (window.__pdmSubscriptionToggleInitialized || ++attempts >= 80) clearInterval(poll)
  }, 125)
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootPdmSubscriptionToggle)
} else {
  bootPdmSubscriptionToggle()
}
